var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-loader",class:{
        _cold: _vm.variant === 'cold',
        _dark: _vm.variant === 'dark',
        _light: _vm.variant === 'light',
    }})}
var staticRenderFns = []

export { render, staticRenderFns }